// src/i18n.ts
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

export const i18nReady = i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // let detector pick it; 'en' is the fallback
    fallbackLng: "en",
    supportedLngs: ["en", "ar"],

    // you're using a single ns named "translation"
    ns: ["translation"],
    defaultNS: "translation",

    debug: false,

    backend: {
      // single JSON per language: /public/locales/en.json, /public/locales/ar.json
      loadPath: "/locales/{{lng}}.json",
    },

    // ✅ valid DetectorOptions (no hash option needed)
    detection: {
      order: ["localStorage", "cookie", "htmlTag", "navigator"],
      caches: ["localStorage", "cookie"],
      lookupLocalStorage: "i18nextLng",
    },

    react: { useSuspense: true },
    interpolation: { escapeValue: false },
  });

export default i18n;
